const TIENDAS = (state, tiendas) => {
    state.tiendas = tiendas;
};

const PROVEEDORES = (state, proveedores) => {
    state.proveedores = proveedores;
};

const PILOTOS = (state, pilotos) => {
    state.pilotos = pilotos;
};

const ACTIVOS_FIJOS = (state, activos_fijos) => {
    state.activos_fijos = activos_fijos;
};


const PRODUCTOS = (state, productos) => {
    state.productos = productos;
};

const CATEGORIAS = (state, categorias) => {
    state.categorias = categorias;
};

const SUBCATEGORIAS = (state, subcategorias) => {
    state.subcategorias = subcategorias;
};

const UNIDADES_MEDIDAS = (state, unidades_medidas) => {
    state.unidades_medidas = unidades_medidas;
};

const BANCOS = (state, bancos) => {
    state.bancos = bancos;
};

const CUENTAS = (state, cuentas) => {
    state.cuentas = cuentas;
};

const CUENTAS_BANCARIAS = (state, cuentas_bancarias) => {
    state.cuentas_bancarias = cuentas_bancarias;
};

const POSICION = (state, posicion) => {
    state.posicion = posicion;
};

const CLIENTES = (state, clientes) => {
    state.clientes = clientes;
};

const CENTRO_COSTO = (state, centro_costo) => {
    state.centro_costo = centro_costo;
};

const CUENTA_CONTABLE = (state, cuenta_contable) => {
    state.cuenta_contable = cuenta_contable;
};

const FORMAS_PAGO = (state, formas_pago) => {
    state.formas_pago = formas_pago;
};

const LISTA_PRECIO = (state, lista_precio) => {
    state.lista_precio = lista_precio;
};


export default {
    TIENDAS,
    PROVEEDORES,
    ACTIVOS_FIJOS,
    PILOTOS,
    PRODUCTOS,
    CATEGORIAS,
    SUBCATEGORIAS,
    UNIDADES_MEDIDAS,
    BANCOS,
    CUENTAS,
    CUENTAS_BANCARIAS,
    POSICION,
    CLIENTES,
    CENTRO_COSTO,
    CUENTA_CONTABLE,
    FORMAS_PAGO,
    LISTA_PRECIO,
};